/* eslint-disable */

/**
 * Variant specifications switcher.
 * - Shows the .js-variant-label group matching the current variant.
 * - Hides the entire <variant-label> wrapper when the active group has
 *   data-empty="true" (meaning that variant has no spec metafields).
 * - Listens for on:variant:change from <variant-picker>.
 *
 * NOTE: Bind eagerly in constructor — do NOT use initLazyScript here,
 * otherwise the listener may not be attached when the user changes the
 * variant, which would leave the wrapper stuck in its initial state.
 */
if (!customElements.get('variant-label')) {
  class VariantLabel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.variantLabels = this.querySelectorAll('.js-variant-label');
      if (!this.variantLabels || this.variantLabels.length === 0) return;

      // Apply initial visibility based on the variant marked current.
      if (this.dataset.currentVariantId) {
        this.setVisibleVariantLabel(this.dataset.currentVariantId);
      }

      this.bindToVariantPicker();
    }

    bindToVariantPicker() {
      const productEl =
        this.closest('.product') ||
        this.closest('.js-product') ||
        this.closest('main') ||
        document;

      const picker = productEl.querySelector('variant-picker');

      if (picker) {
        picker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
        return;
      }

      // <variant-picker> not yet upgraded/parsed. Retry briefly.
      let tries = 0;
      const interval = setInterval(() => {
        tries += 1;
        const p = productEl.querySelector('variant-picker');
        if (p) {
          p.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
          clearInterval(interval);
        } else if (tries > 20) {
          clearInterval(interval);
        }
      }, 150);
    }

    /**
     * Shows the matching group and hides the wrapper if the active group
     * has data-empty="true".
     * @param {string|number} variantId
     */
    setVisibleVariantLabel(variantId) {
      const id = variantId.toString();
      let activeGroup = null;

      this.variantLabels.forEach((el) => {
        const match = el.dataset.variantId.toString() === id;
        el.hidden = !match;
        if (match) activeGroup = el;
      });

      if (activeGroup && activeGroup.dataset.empty === 'true') {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    }

    /**
     * @param {CustomEvent} evt - on:variant:change from <variant-picker>
     */
    handleVariantChange(evt) {
      if (evt.detail && evt.detail.variant) {
        this.setVisibleVariantLabel(evt.detail.variant.id);
      }
    }
  }

  customElements.define('variant-label', VariantLabel);
}
